export enum ShipmentStatus {
  All = 'all',
  Pending = 'pending',
  InformationReceived = 'information_received',
  AvailableForPickup = 'available_for_pickup',
  OutForDelivery = 'out_for_delivery',
  Delivered = 'delivered',
  InTransit = 'in_transit',
  Expired = 'expired',
  Exception = 'exception',
  FailedAttempt = 'failed_attempt',
  CourierNotSupported = 'courier_not_supported',
  NotFound = 'not_found',
  OverQuota = 'over_quota',
  CourierNotDetected = 'courier_not_detected',
  OutOfRange = 'out_of_range',
}

export enum ShipmentPushStatus {
  PROCESSING = 0,
  COMPLETED = 1,
  OVER_QUOTA = 2,
  OTHER = 3,
  NOT_DETECT = 4,
  OUT_RANGE_QUOTA = 5,
}
